var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoInformationStandard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  fillRule: "evenodd",
  d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12m0 2A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 5.006c0 .546.448.994.994.994C8.539 6 9 5.552 9 5.006A1.02 1.02 0 0 0 7.994 4C7.448 4 7 4.46 7 5.006M8 7a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1",
  clipRule: "evenodd"
})));
export default SvgIcoInformationStandard;